import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import { resolveControlAria, useFieldBinding } from "./field";
import { classNames } from "./internal/class-names";

type NativeFileInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "aria-describedby" | "aria-invalid" | "type"
>;

export interface FileInputProps extends NativeFileInputProps {
  readonly describedBy?: string | undefined;
  readonly invalid?: boolean | undefined;
  readonly ref?: Ref<HTMLInputElement> | undefined;
}

/** Central file chooser used by upload and capture workflows. */
export function FileInput({
  className,
  describedBy,
  invalid,
  ...rest
}: FileInputProps): ReactNode {
  const aria = resolveControlAria(useFieldBinding(), {
    describedBy,
    disabled: rest.disabled,
    id: rest.id,
    invalid,
    required: rest.required,
  });

  return (
    <input
      {...rest}
      aria-describedby={aria.describedBy}
      aria-invalid={aria.invalid}
      className={classNames("thw-control", "thw-input", "thw-file-input", className)}
      disabled={aria.disabled}
      id={aria.id}
      required={aria.required}
      type="file"
    />
  );
}
